module.exports = __webpack_public_path__ + "static/img/20008 (4).667e7dc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20008 (4).webp
// module id = 54L9
// module chunks = 14